/* js/animations.js - Scroll Animations */
function initAnimations() {
  // Intersection Observer for scroll reveals
  const fadeUpObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeUpObserver.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  });

  document.querySelectorAll('.fade-up, .reveal-image-wrapper').forEach(element => {
    fadeUpObserver.observe(element);
  });

  // Parallax effect for hero
  const heroImage = document.querySelector('.hero-image');
  if (heroImage) {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY < window.innerHeight) {
        heroImage.style.transform = `translateY(${scrollY * 0.3}px)`;
      }
    });
  }
}
